module.exports = __webpack_public_path__ + "static/media/ChurchOfJesusChrist.e9dc57fd.png";